<app-settings-page [intervention]="intervention" [hasAdminPermissions]="hasAdminPermissions"></app-settings-page>
